import {
  AreaChart,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  ReferenceLine,
} from "recharts";
import { BarChart3 } from "lucide-react";
import "./MonthlyTrends.scss";

const AverageInterviewDuration = ({ dashboardData }) => {
  const last5Months = dashboardData?.last5Months || [];

  const chartData = last5Months.map((item, index) => ({
    name: item.name ?? String(index + 1),
    value: item.avgDuration ?? 0,
  }));

  const latestValue =
    last5Months.length > 0
      ? (last5Months[last5Months.length - 1]?.avgDuration ?? 0)
      : 0;

  return (
    <div className="chart-container avg-duration">
      <div className="avg-duration__header">
        <BarChart3 className="avg-duration__icon" size={18} />
        <h3 className="avg-duration__title">Avg. Interview Duration</h3>
      </div>

      <div className="avg-duration__stats">
        <span className="avg-duration__value">{latestValue} mins</span>
        <span className="avg-duration__label">This Month</span>
      </div>

      <div className="avg-duration__chart p-3">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={chartData}
            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient
                id="avgDurationGradient"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop
                  offset="0%"
                  stopColor="hsl(220, 50%, 35%)"
                  stopOpacity={1}
                />
                <stop
                  offset="100%"
                  stopColor="hsl(185, 45%, 75%)"
                  stopOpacity={0.95}
                />
              </linearGradient>
            </defs>
            <XAxis dataKey="name" hide />
            <YAxis hide domain={[0, "auto"]} />
            <Tooltip
              content={({ active, payload }) => {
                if (!active || !payload?.length) return null;
                const { name, value } = payload[0].payload;
                return (
                  <div className="monthly-trends__tooltip">
                    <div className="monthly-trends__tooltip-row">
                      <span className="monthly-trends__tooltip-label">
                        Month
                      </span>
                      <span className="monthly-trends__tooltip-value">
                        {name}
                      </span>
                    </div>
                    <div className="monthly-trends__tooltip-row">
                      <span className="monthly-trends__tooltip-label">
                        Avg. Duration (mins)
                      </span>
                      <span className="monthly-trends__tooltip-value">
                        {value}
                      </span>
                    </div>
                  </div>
                );
              }}
              cursor={{ fill: "rgba(0,0,0,0.04)" }}
            />
            <Area
              type="monotone"
              dataKey="value"
              stroke="hsl(220, 50%, 35%)"
              strokeWidth={2}
              fill="url(#avgDurationGradient)"
              fillOpacity={1}
            />
            {chartData
              .filter(
                (point) => typeof point.value === "number" && point.value > 0,
              )
              .map((point) => (
                <ReferenceLine
                  key={point.name}
                  x={point.name}
                  stroke="rgba(255, 255, 255, 0.95)"
                  strokeDasharray="4 4"
                  strokeWidth={2}
                />
              ))}
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AverageInterviewDuration;
